export default __webpack_public_path__ + "static/media/spei.b7246188.svg";